import React from 'react';
import moment from 'moment';

import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';
import SupportFileRow from './SupportFileRow';
import { useSelector } from 'react-redux';

const SupportChatReplyCard = ({ reply, supportChat, handleDeleteSupportChatReply, disableSupportChat }) => {
  const { t } = useTranslation();
  const accountReducer = useSelector(state => state.AccountReducer);

  const { profile } = accountReducer;
  const handleDeleteNoteReply = () => {
    handleDeleteSupportChatReply(reply);
  };

  return (
    <Box direction="row" justify="flex-start" alignItems="flex-start" marginLeft={5}>
      <Typography>
        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>{reply.userFullName}</span>{' '}
        <span style={{ fontSize: '14px' }}>- {moment(reply.dateCreated).fromNow()}</span>
      </Typography>

      <Typography justifyContent={'center'} sx={{ mt: 1 }}>
        <div
          dangerouslySetInnerHTML={{
            __html: reply.note.replace(/\n/gi, '<br />'),
          }}
        />
      </Typography>
      <Box sx={{ height: '4rem', display: 'flex', flexDirection: 'row' }}>
        {reply.files?.map(f => (
          <SupportFileRow file={f} readOnly styleProps={{ ml: 0 }} />
        ))}
      </Box>
      <div style={{ textAlign: 'right' }}>
        <Button
          simple
          style={{ paddingLeft: 0 }}
          size="sm"
          color="danger"
          disabled={disableSupportChat || reply.user_Id !== profile.person.user_Id}
          onClick={_ => handleDeleteNoteReply()}>
          {t('delete')}
        </Button>
      </div>
    </Box>
  );
};

export default SupportChatReplyCard;
